/* eslint no-console:0 no-alert:0 */
import React, {useState} from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"
  import Translation from "../Translation"
import addToMailchimp from 'gatsby-plugin-mailchimp'
import ButtonLink from "../ButtonLink"
import {LeftColumn} from "../SharedStyledComponents"
import {margin} from "styled-system"
import {translateMessageId} from "../../utils/translations"
import { useIntl } from "gatsby-plugin-intl"


const StyledInput = styled.input`
  border: 1px solid ${(props) => props.theme.colors.searchBorder};
  color: ${(props) => props.theme.colors.text};
  background: ${(props) => props.theme.colors.searchBackground};
  padding: 0.5rem;
  padding-right: 2rem;
  border-radius: 0.25em;
  width: 100%;

  &:focus {
    outline: ${(props) => props.theme.colors.primary} auto 1px;
  }
`

const StyledButton = styled(StyledInput)`
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25em;
  text-align: center;
  width: fit-content;
  ${margin}
`

const Primary = styled(StyledButton)`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.buttonColor} !important;
  border: 1px solid transparent;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryHover};
    box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
  }
  &:active {
    background-color: ${(props) => props.theme.colors.primaryActive};
  }
`

const Secondary = styled(StyledButton)`
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  background-color: transparent;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
    box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
  }
  &:active {
    background-color: ${(props) =>
      props.theme.colors.secondaryButtonBackgroundActive};
  }
`

const Subtitle = styled.h2`
  font-size: 1.25rem;
  line-height: 1.4;
  font-weight: 400;
  color: ${(props) => props.theme.colors.text300};
  max-width: 55ch;
  margin-bottom: 0.5rem;
  margin-top: 1rem;
`
const StyledH2 = styled.h2`
  margin-bottom: 0.5rem;
  font-family: serif;
  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    font-size: 24px;
  }
`
const Form = styled.form`
  margin: 0;
  position: relative;
  border-radius: 0.25em;
`

const NftContainer = styled.div`
  background: ${(props) => props.theme.colors.homeBoxMint};
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 720px;
  margin-top: -1px;
  border-top: 1px solid ${(props) => props.theme.colors.text};
  border-bottom: 1px solid ${(props) => props.theme.colors.text};
  @media (max-width: ${(props) => props.theme.breakpoints.l}) {
    flex-direction: column-reverse;
    height: 100%;
    height: 100%;
    padding-top: 2rem;
    padding-right: 0rem;
    padding-bottom: 2rem;
  }
`

      const Row = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          align-items: center;
        }
      `
      const ImageContainer = styled.div`
        background: "#F1FFFD";
        display: flex;
        height: 100%;
        width: 100%;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          width: 75%;
        }
      `
      const FeatureImage = styled(GatsbyImage)`
        width: 100%;
      `

      const FeatureContent = styled(LeftColumn)`
        padding: 6rem;
        height: 100%;
        width: 100%;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          padding: 2rem;
        }
      `

      const LeftColumnContent = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
      `

const AddToMailchimp = ({image, alt})=>{

  /* state = {
      name: null,
      email: null,
  }*/

  const intl = useIntl()

  let [name, setName] = useState(null)
  let [email, setEmail] = useState(null)



  const _handleChange = e => {
      console.log({
          [`${e.target.name}`]: e.target.value,
      })
      /*this.setState({
          [`${e.target.name}`]: e.target.value,
      })*/
      switch (e.target.name) {
        case "name":
          setName(e.target.value)
          break;
        case "email":
          setEmail(e.target.value)
          break;
        default:

      }
  }

  const _handleSubmit = e => {
      e.preventDefault()

      console.log('submit', {name, email})

      /*addToMailchimp(email, {name})
          .then(({ msg, result }) => {
              console.log('msg', `${result}: ${msg}`)

              if (result !== 'success') {
                  throw msg
              }
              alert(msg)
          })
          .catch(err => {
              console.log('err', err)
              alert(err)
          })*/
  }

  return (
    <NftContainer>
      <Row>
        <ImageContainer>
        <FeatureImage
          image={image}
          alt={alt}
        />
        </ImageContainer>
        <FeatureContent>
          <LeftColumnContent>
            <StyledH2>
              <Translation id="callout-subscription-title" />
            </StyledH2>
            <Subtitle>
              <Translation id="callout-subscription-description" />
            </Subtitle>
            <Form onSubmit={_handleSubmit}>
                <StyledInput
                    type="text"
                    onChange={_handleChange}
                    placeholder="name"
                    name="name"
                />
                <StyledInput
                    type="email"
                    onChange={_handleChange}
                    placeholder="email"
                    name="email"
                />
                <div>
                  <Primary type="submit" value={translateMessageId("callout-subscription-signup-button", intl)}/>
                </div>
            </Form>
          </LeftColumnContent>
        </FeatureContent>
      </Row>
    </NftContainer>
  )

}

export default AddToMailchimp
